import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";

const JobDescription = ({ description }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(500);

  useEffect(() => {
    if (!description || !iframeRef.current) return;

    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
            body {
              margin: 0;
              padding: 16px;
              font-family: Arial, sans-serif;
            }
            table {
              border-collapse: collapse;
            }
          </style>
        </head>
        <body>
          ${description}
        </body>
      </html>
    `);
    doc.close();

    const adjustHeight = () => {
      try {
        const body = doc.body;
        const html = doc.documentElement;
        const height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight,
          500
        );
        setIframeHeight(Math.min(height, 800));
      } catch {
        setIframeHeight(500);
      }
    };

    setTimeout(adjustHeight, 100);
    setTimeout(adjustHeight, 500);
  }, [description]);

  if (!description) return null;

  return (
    <div className="card mb-4">
      <div className="card-body p-0">
        <iframe
          ref={iframeRef}
          title="Job Description"
          style={{
            width: "100%",
            height: `${iframeHeight}px`,
            border: "none",
            minHeight: "500px",
          }}
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  );
};

JobDescription.propTypes = {
  description: PropTypes.string,
};

export default JobDescription;
